import {AuthData} from '@core/services';
import {AuthActionTypes, AuthActions} from '@store/actions/auth.actions';
import {AppStateMetaData} from '@store/state';

export interface AuthState {
  userID?: number;
  actingAsID?: number;
  isLoggedin: boolean;
  authData: AuthData;
  forgotPasswordResult: any;
  validateResetPasswordCodeResult: any;
  metadata?: AppStateMetaData;
  privacyPolicyContent?: string;
}

export const initialState: AuthState = {
  userID: null,
  actingAsID: null,
  isLoggedin: false,
  authData: null,
  forgotPasswordResult: null,
  validateResetPasswordCodeResult: null,
  privacyPolicyContent: null,
  metadata: {loaded: false, loading: false}
};

export function reducer(state = initialState, action: AuthActions): AuthState {
  switch (action.type) {
    case AuthActionTypes.Login: {
      return initialState;
    }

    case AuthActionTypes.LoginSuccess:
      return {
        ...state,
        authData: action.payload,
        userID: action.payload.userId,
        isLoggedin: true
      };
    case AuthActionTypes.Logout: {
      return initialState;
    }
    case AuthActionTypes.SetToken:
      break;

    case AuthActionTypes.ForgotPasswordSuccess:
      return {
        ...state,
        forgotPasswordResult: action.payload.forgotPasswordResult
      };
    case AuthActionTypes.ValidateResetPasswordCodeSuccess:
      return {
        ...state,
        validateResetPasswordCodeResult: action.payload
      };
    case AuthActionTypes.GetPrivacyPolicyContentSuccess:
      return {
        ...state,
        privacyPolicyContent: action.payload
      };
    default:
      break;
  }

  return state;
}
export const getForgotPasswordResult = (state: AuthState) =>
  state.forgotPasswordResult;
export const getPrivacyPolicyContent = (state: AuthState) =>
  state.privacyPolicyContent;

export const getValidateResetPasswordCodeResult = (state: AuthState) =>
  state.validateResetPasswordCodeResult;

export const getIsLoggedIn = (state: AuthState) => state.isLoggedin;
export const getAuthData = (state: AuthState) => state.authData;
